export default __webpack_public_path__ + "static/media/avatar_merlion7.759e02de.mp3";